<!--
  AiTaskSections.vue — AI 任务区域（Vidu / 对口型 / 绘画）
-->
<template>
  <div>
    <!-- ==================== Vidu 视频 ==================== -->
    <section class="uq-section">
      <div class="uq-section-title">Vidu视频任务</div>
      <div
        v-if="tasksLoading"
        class="uq-loading-text"
      >加载中...</div>
      <div
        v-else-if="!viduTasks.length"
        class="uq-empty-text"
      >暂无任务</div>
      <table
        v-else
        class="uq-table"
      >
        <thead>
          <tr>
            <th>任务编号</th>
            <th>状态</th>
            <th>尺寸</th>
            <th>原图</th>
            <th>封面</th>
            <th>视频</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="t in viduTasks"
            :key="t.taskNo"
          >
            <td class="uq-mono">{{ t.taskNo }}</td>
            <td><span :class="viduStatusClass(t.state)">{{ t.state }}</span></td>
            <td>{{ t.width }}×{{ t.height }}</td>
            <td><img
                v-if="t.image"
                :src="t.image"
                class="uq-thumb"
                @click="$emit('preview', t.image)"
              /></td>
            <td><img
                v-if="t.cover"
                :src="t.cover"
                class="uq-thumb"
                @click="$emit('preview', t.cover)"
              /></td>
            <td><a
                v-if="t.video"
                :href="t.video"
                target="_blank"
                rel="noopener noreferrer"
              >播放</a></td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="viduTasks.length"
        class="uq-pagination"
      >
        <button
          :disabled="viduPage <= 1"
          @click="$emit('page', 'vidu', viduPage - 1)"
        >上一页</button>
        <span>{{ viduPage }} / {{ viduPageCount }}</span>
        <button
          :disabled="viduPage >= viduPageCount"
          @click="$emit('page', 'vidu', viduPage + 1)"
        >下一页</button>
      </div>
    </section>

    <!-- ==================== 对口型 ==================== -->
    <section class="uq-section">
      <div class="uq-section-title">对口型视频任务</div>
      <div
        v-if="tasksLoading"
        class="uq-loading-text"
      >加载中...</div>
      <div
        v-else-if="!lipSyncTasks.length"
        class="uq-empty-text"
      >暂无任务</div>
      <table
        v-else
        class="uq-table"
      >
        <thead>
          <tr>
            <th>任务编号</th>
            <th>标题</th>
            <th>文本/音频</th>
            <th>状态</th>
            <th>进度</th>
            <th>时长</th>
            <th>封面</th>
            <th>视频</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="t in lipSyncTasks"
            :key="t.taskNo"
          >
            <td class="uq-mono">{{ t.taskNo }}</td>
            <td>{{ t.title }}</td>
            <td class="uq-prompt-cell">{{ t.audioType === 0 ? t.tts : '音频文件' }}</td>
            <td><span :class="lipSyncStatusClass(t.status)">{{ lipSyncStatusText(t.status) }}</span></td>
            <td>{{ t.progress }}%</td>
            <td>{{ t.duration }}s</td>
            <td><img
                v-if="t.cover"
                :src="t.cover"
                class="uq-thumb"
                @click="$emit('preview', t.cover)"
              /></td>
            <td><a
                v-if="t.videoUrl"
                :href="t.videoUrl"
                target="_blank"
                rel="noopener noreferrer"
              >播放</a></td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="lipSyncTasks.length"
        class="uq-pagination"
      >
        <button
          :disabled="lipSyncPage <= 1"
          @click="$emit('page', 'lipSync', lipSyncPage - 1)"
        >上一页</button>
        <span>{{ lipSyncPage }} / {{ lipSyncPageCount }}</span>
        <button
          :disabled="lipSyncPage >= lipSyncPageCount"
          @click="$emit('page', 'lipSync', lipSyncPage + 1)"
        >下一页</button>
      </div>
    </section>

    <!-- ==================== 绘画 ==================== -->
    <section class="uq-section">
      <div class="uq-section-title">绘画任务</div>
      <div
        v-if="tasksLoading"
        class="uq-loading-text"
      >加载中...</div>
      <div
        v-else-if="!drawTasks.length"
        class="uq-empty-text"
      >暂无任务</div>
      <table
        v-else
        class="uq-table"
      >
        <thead>
          <tr>
            <th>任务编号</th>
            <th>描述</th>
            <th>状态</th>
            <th>创建时间</th>
            <th>生成图片</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="t in drawTasks"
            :key="t.taskNo"
          >
            <td class="uq-mono">{{ t.taskNo }}</td>
            <td class="uq-prompt-cell">{{ t.description }}</td>
            <td><span :class="taskStatusClass(t.status)">{{ taskStatusText(t.status) }}</span></td>
            <td>{{ t.createTime }}</td>
            <td><img
                v-if="t.image"
                :src="t.image"
                class="uq-thumb"
                @click="$emit('preview', t.image)"
              /></td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="drawTasks.length"
        class="uq-pagination"
      >
        <button
          :disabled="drawPage <= 1"
          @click="$emit('page', 'draw', drawPage - 1)"
        >上一页</button>
        <span>{{ drawPage }} / {{ drawPageCount }}</span>
        <button
          :disabled="drawPage >= drawPageCount"
          @click="$emit('page', 'draw', drawPage + 1)"
        >下一页</button>
      </div>
    </section>
  </div>
</template>

<script>
import {
  taskStatusText,
  taskStatusClass,
  viduStatusClass,
  lipSyncStatusText,
  lipSyncStatusClass,
} from "@/utils/formatters";

export default {
  name: "UserQueryAiTaskSections",
  props: {
    tasksLoading: Boolean,
    viduTasks: Array,
    viduPage: Number,
    viduPageCount: Number,
    lipSyncTasks: Array,
    lipSyncPage: Number,
    lipSyncPageCount: Number,
    drawTasks: Array,
    drawPage: Number,
    drawPageCount: Number,
  },
  emits: ["preview", "page"],
  methods: {
    taskStatusText,
    taskStatusClass,
    viduStatusClass,
    lipSyncStatusText,
    lipSyncStatusClass,
  },
};
</script>

<style scoped>
.uq-section {
  margin-bottom: 24px;
}
.uq-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #37352f;
  margin-bottom: 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8e5e0;
}
.uq-loading-text,
.uq-empty-text {
  font-size: 14px;
  color: #9b9a97;
  padding: 12px 0;
}
.uq-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.uq-table th {
  text-align: left;
  padding: 8px 10px;
  font-weight: 500;
  color: #9b9a97;
  border-bottom: 1px solid #e8e5e0;
  white-space: nowrap;
}
.uq-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #f0efed;
  vertical-align: top;
}
.uq-table tr:hover td {
  background: #fbfbfa;
}
.uq-mono {
  font-family: "SFMono-Regular", Menlo, Consolas, monospace;
  font-size: 12px;
}
.uq-prompt-cell {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.uq-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 3px;
  cursor: pointer;
  transition: opacity 0.15s;
}
.uq-thumb:hover {
  opacity: 0.8;
}
.uq-tag-green {
  background: #dbeddb;
  color: #2d6a2e;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}
.uq-tag-red {
  background: #fbe4e4;
  color: #c4554d;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}
.uq-tag-blue {
  background: #d3e5ef;
  color: #2878b5;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}
.uq-tag-gray {
  background: #e8e5e0;
  color: #6b6966;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
}
.uq-pagination {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  font-size: 13px;
  color: #9b9a97;
}
.uq-pagination button {
  padding: 4px 12px;
  font-size: 13px;
  background: #ffffff;
  border: 1px solid #e8e5e0;
  border-radius: 4px;
  cursor: pointer;
  color: #37352f;
  transition: background 0.1s;
}
.uq-pagination button:hover:not(:disabled) {
  background: #f0efed;
}
.uq-pagination button:disabled {
  color: #c4c4c4;
  cursor: not-allowed;
}
</style>
